package org.mackclan.chat

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import io.ktor.client.HttpClient
import io.ktor.client.engine.js.*
import io.ktor.client.plugins.websocket.WebSockets

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    val client = HttpClient(Js) {
        install(WebSockets)
    }

    ComposeViewport {
        App(client)
    }
}